const autoNgTemplateLoaderTemplate1 = require('./summary.html');

angular.module('shbdeployer.kubernetes').component('kubernetesSummaryView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesSummaryController',
  controllerAs: '$ctrl',
  bindings: {
    formValues: '<',
    oldFormValues: '<',
  },
});
